import { createSlice } from '@reduxjs/toolkit';
import { getFormUpdater } from '../../services/common/miscUtils';
import { saveAndContinueRehydrateSlice } from '../../services/redux/storeUtils';
import { ReduxStateWithForms, ReduxTrackedForm, createReduxTrackedFormDefaults } from '../../types/reduxTrackedForm';
import { FinancialDetailsFormModel } from './financialDetailsForm.model';

export interface FinancialDetailsFormState extends ReduxStateWithForms<{
  financialDetails1: ReduxTrackedForm<FinancialDetailsFormModel>;
  financialDetails2: ReduxTrackedForm<FinancialDetailsFormModel>;
}> {}

const financialDetailsInitialValues: FinancialDetailsFormModel = {
  frequencyOfNetIncome: undefined,
  netMonthlyIncome: undefined,
  additionalIncome: [],
  financialObligations: undefined,
};

const initialState: FinancialDetailsFormState = {
  forms: {
    financialDetails1: {
      ...createReduxTrackedFormDefaults<FinancialDetailsFormModel>({ initialValues: financialDetailsInitialValues }),
      values: {
        ...financialDetailsInitialValues,
      },
    },
    financialDetails2: {
      ...createReduxTrackedFormDefaults<FinancialDetailsFormModel>({
        excluded: true,
        initialValues: financialDetailsInitialValues,
      }),
      values: {
        ...financialDetailsInitialValues,
      },
    },
  },
};

const name = 'financialDetailsForm';

const slice = createSlice({
  name,
  initialState,
  selectors: {
    financialDetailsForm1Triggers: (state) => state.forms.financialDetails1.triggers,
    financialDetailsForm2Triggers: (state) => state.forms.financialDetails2.triggers,
    financialDetails1Values: (state) => state.forms.financialDetails1.values,
    financialDetails2Values: (state) => state.forms.financialDetails2.values,
    forms: (state) => state.forms,
  },
  reducers: {
    updateForm: getFormUpdater<FinancialDetailsFormState>(),
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, name);
  },
});

export const financialDetailsFormSlice = slice;
export const financialDetailsFormSliceSelectors = slice.selectors;
export const financialDetailsFormSliceActions = slice.actions;
